<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog
      v-model="dialog"
      width="450">
      <v-card class="pa-4" v-if="Object.keys(detail).length > 0">
        <v-card-title class="body-2 pb-5">
          {{ detail.logNotification.title }}
        </v-card-title>
        <v-card-subtitle class="caption pb-3">
          {{ detail.logDatetime | datetime }}
        </v-card-subtitle>
        <v-card-text class="body-2 font-weight-light pb-3" v-html="convert(detail.logNotification.body)"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="120"
            color="#3a3a3a"
            elevation="0"
            class="white--text text-capitalize"
            @click="dialog = false"
            :to="`/transaction/selling/${detail.logInvoiceId}`">
            Lihat Detail
          </v-btn>
          <v-btn
            rounded
            small
            width="70"
            elevation="0"
            light
            class="text-capitalize"
            @click="dialog = false">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="3">
          <v-expansion-panels 
            multiple
            flat
            v-model="panel">
            <v-expansion-panel
              style="position: initial; background: transparent;"
              class="mt-0">
              <v-expansion-panel-header class="font-weight-bold">
                <div class="d-flex align-baseline">
                  <v-icon small>mdi-filter</v-icon>
                  <div class="ml-1 body-2 text--secondary">
                    Filter
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-radio-group v-model="sort.selected" :mandatory="false" class="mt-0">
                  <v-radio 
                    color="#3a3a3a"
                    v-for="(submenu, index) in sort.submenu"
                    :key="index" 
                    :label="submenu.text" 
                    :value="submenu.value"
                    v-on:change="toSort(submenu.value)"
                    class="py-1">
                  </v-radio>
                </v-radio-group>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col cols="12" md="9">
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.run"
            transition="scale-transition"
            :tile="false"
            type="list-item-two-line"
            v-for="(l, index) in process.run ? 10:list" 
            :key="index">
            <v-list dense class="line mb-3">
              <v-list-item v-if="!process.run && list.length > 0"
                class="px-0 c-p"
                @click="toRead(l)">
                <v-list-item-avatar>
                  <v-icon :color="l.logStatusOpen === 'yes' ? 'grey' : 'yellow darken-4'">mdi-bell</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="body-2 ">
                    {{ l.logNotification.title }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption mt-1 font-weight-light">
                    {{ l.logDatetime | datetime }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="body-2 mt-1 font-weight-light" v-html="convert(l.logNotification.body)"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-skeleton-loader>
          <Empty v-show="!process.run && list.length < 1" content="Data Pemberitahuan"/>
        </v-col>
        <v-col cols="12">
          <div class="float-right" v-if="pagination.totalPage > 1">
            <v-pagination
              v-model="page"
              :length="pagination.totalPage"
              :total-visible="5"
              color="#3a3a3a"
              @input="fetch(page)"
              circle>
            </v-pagination>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import Empty from "../../components/DataEmpty";
  export default {
    data () {
      return {
        list: [],
        pagination: {},
        page: 1,
        keyword: '',
        panel: [0],
        sort: {
          selected: 'all',
          submenu: [
            {
              value: 'all',
              text: 'Semua',
            },
            {
              value: 'no',
              text: 'Belum Dibaca',
            },
            {
              value: 'yes',
              text: 'Sudah Dibaca',
            }
          ]
        },
        dialog: false,
        detail: {},
        process: {
          run: false
        },
        response: ''
      }
    },
    components: {
      Empty 
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      window.scrollTo(0, 0)
      this.fetch()
    },   
    methods: {  
      async fetch(p) {
        if (p === undefined) {
          this.page = 1
        } 
        this.process.run = true
        await get(`internal/notif`, {
          params: {
            pagenum: p,
            limit: 10,
            sort: this.sort.selected === 'all' ? '' : this.sort.selected
          }
        })
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.list = res.data
            this.pagination = res.pagination
          }
        })
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
      toSort(value) {
        this.sort.selected = value
        this.fetch()
      },
      toRead(value) {
        this.detail = value
        put(`internal/notif/update/status/${this.detail.id}`, {
          data: {
            status: "yes"
          }
        })
        .then((response) => {
          if (response.data.code === 201) {
            this.fetch()
            this.dialog = true
          }
        })
      }
    }
  }
</script>